module.exports = __webpack_public_path__ + "img/filter-active.f57bc975.svg";